if (!customElements.get('bn-granola-builder')) {
  customElements.define(
    'bn-granola-builder',
    class BnGranolaBuilder extends HTMLElement {
      connectedCallback() {
        this.formId = this.dataset.formId;
        this.form = document.getElementById(this.formId);
        this.steps = [...this.querySelectorAll('[data-granola-step]')];
        this.progress = this.querySelector('[data-granola-progress]');
        this.summary = this.querySelector('[data-granola-summary]');
        this.errorEl = this.querySelector('[data-granola-error]');
        this.current = 0;

        this.inputs = {
          fruit: this.querySelector('[data-granola-input="fruit"]'),
          seed: this.querySelector('[data-granola-input="seed"]'),
          coco: this.querySelector('[data-granola-input="coco"]'),
        };

        this.submitButtons = this.getSubmitButtons();
        this.setSubmitDisabled(true);

        this.querySelectorAll('[data-granola-next]').forEach((btn) => {
          btn.addEventListener('click', () => {
            if (btn.hasAttribute('data-granola-submit')) {
              this.submitToCart();
            } else {
              this.goNext();
            }
          });
        });
        this.querySelectorAll('[data-granola-back]').forEach((btn) => {
          btn.addEventListener('click', () => this.goBack());
        });

        this.querySelectorAll('[data-granola-option]').forEach((input) => {
          input.addEventListener('change', () => this.onOptionChange(input));
        });

        if (this.form) {
          this.form.addEventListener('submit', (e) => {
            if (!this.isComplete()) {
              e.preventDefault();
              e.stopPropagation();
              this.showError();
              this.goToFirstIncomplete();
            }
          });
        }

        this.showStep(0);
      }

      getSubmitButtons() {
        const buttons = [];
        if (this.form) {
          buttons.push(...this.form.querySelectorAll('[type="submit"][name="add"]'));
        }
        document
          .querySelectorAll(`[form="${this.formId}"][type="submit"]`)
          .forEach((btn) => buttons.push(btn));
        return [...new Set(buttons)];
      }

      setSubmitDisabled(disabled) {
        this.submitButtons.forEach((btn) => {
          btn.disabled = disabled;
          btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
          btn.classList.toggle('bn-granola-submit--locked', disabled);
        });
      }

      showStep(index) {
        this.current = index;
        this.steps.forEach((step, i) => {
          step.hidden = i !== index;
        });
        if (this.progress) {
          this.progress.textContent = `Paso ${index + 1} de ${this.steps.length}`;
        }
        this.updateNavState();
        this.clearError();
      }

      getStepValue(stepIndex) {
        const step = this.steps[stepIndex];
        if (!step) return '';
        const checked = step.querySelector('[data-granola-option]:checked');
        return checked ? checked.value : '';
      }

      syncInputsFromSelection() {
        this.steps.forEach((step, i) => {
          const key = step.dataset.granolaStep;
          const value = this.getStepValue(i);
          if (key && this.inputs[key]) {
            this.inputs[key].value = value;
          }
        });
      }

      isComplete() {
        return (
          this.inputs.fruit?.value &&
          this.inputs.seed?.value &&
          this.inputs.coco?.value
        );
      }

      onOptionChange(input) {
        const stepEl = input.closest('[data-granola-step]');
        const stepIndex = this.steps.indexOf(stepEl);
        const key = stepEl?.dataset.granolaStep;
        if (key && this.inputs[key]) {
          this.inputs[key].value = input.value;
        }
        this.updateNavState();
        if (stepIndex === this.steps.length - 1 && this.isComplete()) {
          this.renderSummary();
          this.setSubmitDisabled(false);
        } else if (stepIndex < this.steps.length - 1) {
          this.setSubmitDisabled(true);
        }
      }

      updateNavState() {
        this.steps.forEach((step, i) => {
          const nextBtn = step.querySelector('[data-granola-next]');
          if (nextBtn) {
            nextBtn.disabled = !this.getStepValue(i);
          }
        });
      }

      goNext() {
        if (!this.getStepValue(this.current)) return;
        if (this.current < this.steps.length - 1) {
          this.showStep(this.current + 1);
        }
      }

      submitToCart() {
        if (!this.getStepValue(this.current)) return;
        this.syncInputsFromSelection();
        if (!this.isComplete()) {
          this.showError();
          this.goToFirstIncomplete();
          return;
        }

        this.renderSummary();
        this.setSubmitDisabled(false);
        this.clearError();

        const submitBtn = this.submitButtons.find(
          (btn) => btn.type === 'submit' && btn.name === 'add'
        );
        if (!submitBtn) return;

        if (submitBtn.disabled || submitBtn.getAttribute('aria-disabled') === 'true') {
          return;
        }

        submitBtn.click();
      }

      goBack() {
        if (this.current > 0) {
          this.setSubmitDisabled(true);
          if (this.summary) this.summary.hidden = true;
          this.showStep(this.current - 1);
        }
      }

      goToFirstIncomplete() {
        for (let i = 0; i < this.steps.length; i += 1) {
          if (!this.getStepValue(i)) {
            this.showStep(i);
            return;
          }
        }
      }

      renderSummary() {
        if (!this.summary) return;
        const parts = [
          ['Fruta', this.inputs.fruit?.value],
          ['Semilla', this.inputs.seed?.value],
          ['Coco slice', this.inputs.coco?.value],
        ];
        this.summary.innerHTML = parts
          .map(
            ([label, value]) =>
              `<div class="bn-granola__summary-row"><span>${label}</span><strong>${value}</strong></div>`
          )
          .join('');
        this.summary.hidden = false;
      }

      showError() {
        if (this.errorEl) {
          this.errorEl.hidden = false;
          this.errorEl.textContent =
            'Completa los 3 pasos para personalizar tu granola antes de agregar al carrito.';
        }
      }

      clearError() {
        if (this.errorEl) this.errorEl.hidden = true;
      }
    }
  );
}
